import _extends from "@babel/runtime/helpers/extends";
/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { Card } from '../Card';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import React from 'react';
import settings from 'carbon-components/es/globals/js/settings';
var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Featured Card Component
 *
 * @param {object} props props object
 * @param {object} props.card section card object
 * @param {Function} props.onClick onClick function
 * @returns {*} FeatureCard JSX component
 */

var FeatureCard = function FeatureCard(_ref) {
  var card = _ref.card,
      onClick = _ref.onClick;
  return card.cta && React.createElement("div", {
    className: "".concat(prefix, "--feature-card"),
    "data-autoid": "".concat(stablePrefix, "--feature-card")
  }, React.createElement(Card, _extends({
    customClassName: "".concat(prefix, "--feature-card__card"),
    onClick: onClick
  }, card)));
};

export default FeatureCard;